import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
    padding: 12px;
    overflow: auto;
    height: 100%;
    box-sizing: border-box;
    font-family: inherit;
    font-size: 20px;
    color: #abb2bf;
  }

  .section-heading {
    margin: 16px 0 6px;
    font-size: 15px;
    color: #528bff;
    text-transform: uppercase;
    letter-spacing: 1.4px;
    font-weight: 700;
  }

  .row {
    display: grid;
    grid-template-columns: 160px 1fr;
    align-items: baseline;
    gap: 10px;
    padding: 6px 10px;
    border-bottom: 1px solid #2c313a;
  }

  .row-label {
    font-size: 16px;
    color: #5c6370;
    white-space: nowrap;
  }

  .row-value {
    font-family: 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace;
    font-size: 18px;
    color: #abb2bf;
    word-break: break-all;
  }

  .env-badge {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 3px;
    font-size: 16px;
    font-weight: 700;
    font-family: 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace;
    text-transform: uppercase;
    border: 1px solid currentColor;
  }
`;
